import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { Fragment } from 'react'

function DropDown({ menuList, title, customStyle, size = '', param, titleColor, menuItemStyle = "  ", textPosition, hideOnEmpty = false, position = 'down', onSelection ,icon,optionIcon}) {
    let sizeCss = 'px-1.5 py-1';
    if (size == 'md') {
        sizeCss = 'px-2 py-1'
    } else if (size == 'md_2') {
        sizeCss = 'px-1.5 py-0.5 text-sm'
    } else if (size == 'sm') {
        sizeCss = 'px-1 py-0.5 text-sm'
    }

    let textPos = 'text-left';
    if (textPosition) {
        textPos = textPosition;
    }

    if (hideOnEmpty && !(menuList && menuList.length)) {
        return '';
    }

    return (
        <div className={`relative ${textPos}`}>

            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <MenuButton className={`inline-flex w-full justify-center gap-x-1.5 px-2 py-2 text-sm font-semibold text-gray-900 ${customStyle ? customStyle : "shadow-sm rounded-md bg-white ring-1 ring-inset ring-gray-300 hover:bg-gray-50"}`}>
                       <span>{icon}</span>
                        {title}
                      {!optionIcon ? 
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`-mr-1 ${title && title != '' && 'ml-2'} h-5 w-5`}>
                                 <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                        </svg> :optionIcon}
                    </MenuButton>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <MenuItems className={` absolute ${position == 'up' ? 'bottom-full' : ''} right-0 z-50 mt-2 min-w-[150px] w-max origin-top-right rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none    ${menuItemStyle}`}>
                        {menuList?.map((v, k) => (
                            <div className="mx-1 my-1" key={k}>
                                {v && (
                                    <MenuItem>
                                        {({ active }) => (
                                            <button
                                                onClick={(e) => {
                                                    v?.onClick && v?.onClick(e, param);
                                                    onSelection && onSelection(v)
                                                }}
                                                className={`${active && 'bg-gray-50'
                                            }  flex w-full font-normal items-center  px-2 py-1   ${v?.labelStyle ? v?.labelStyle : ` text-gray-800 `}  `}
                                            >
                                                {v?.icon}

                                                {v?.label}
                                            </button>
                                        )}
                                    </MenuItem>
                                )}
                            </div>
                        ))}
                    </MenuItems>
                </Transition>
            </Menu>
        </div>
    )
}

export default DropDown